import classNames from "classnames"
import React from "react"

function FeatureSwitch({
  featureId,
  featureName,
  selectedFeature,
  setSelectedFeature,
  nullFeatureAllowed,
}) {
  const checked = selectedFeature === featureId

  const disabled = checked && !nullFeatureAllowed
  return (
    <div
      className={classNames("feature-switch", {
        "feature-switch-disabled": disabled,
      })}
      onClick={() =>
        setSelectedFeature(nullFeatureAllowed && checked ? null : featureId)
      }
    >
      {featureName}
      <div
        className={classNames("custom-switch", {
          "custom-switch-active": checked,
          "custom-switch-disabled": disabled,
        })}
      >
        <div />
      </div>
    </div>
  )
}

export default FeatureSwitch
